<template>
  <v-app>

    <Navbar v-if="!navExclude.includes($route.name)" />

    <v-content>
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </v-content>

    <Footer v-if="!footerExclude.includes($route.name)" />

    <v-snackbar v-model="$store.state.snackState" color="grey darken-3" :timeout="timeout" top right multi-line>
      {{$store.state.snackText}}
      <v-btn color="pink" flat icon @click="$store.state.snackState = !$store.state.snackState">
        Close
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import { Auth } from '@/firebase/auth';
import { DB } from '@/firebase/db';
export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  data () {
    return {
      timeout: 5000,
      navExclude: ['Upload Page'],
      footerExclude: ['Profile Page', 'Upload Page', 'Subscription Page'],
    }
  },
  created() {
    if (localStorage.uid) {
      this.$store.dispatch('setUserState', true)
    }
    
    // Monitors user's Authentication state
    Auth.onAuthStateChanged((user) => {
      if (user) {
        // Updates user login status
        this.$store.dispatch('setUserState', true)

        // Fetches user's data from firestore
        var docRef = DB.collection("users").doc(user.uid);
        docRef.get().then((doc) => {
            if (doc.exists) {

              // Updates user's data when it is retrived
                this.$store.dispatch('setUserData', doc.data())

              // this.$store.dispatch('setSnackText', "Welcome "+ this.$store.state.userData.name)
              localStorage.setItem('uid', user.uid)

              // Runs background check on user's account to check if subscription is still valid
              let info = doc.data()

              let date = new Date()
              let currentTimeStamp = date.getTime()

              if (info.validity < currentTimeStamp) {
                let me = DB.collection("users").doc(info.uid);

                // Set the Updates personal details
                me.update({
                      activated: false,
                })
                .then(() => {
                    // this.$store.dispatch('setSnackText', "Your subscription has expired please renew!")
                    this.$store.dispatch('syncUserData')
                })
                .catch(error => {
                    this.$store.dispatch('setSnackText', "Error updating account: "+error)
                });
              }

            } else {
              // doc.data() will be undefined in this case
              // console.log("Unable to load user's data");
              this.$store.dispatch('setSnackText', "Unable to load user's data")
            }
            
        })
        .then(() => {
            if (localStorage.playerId) {
                var userRef = DB.collection("users").doc(user.uid)

                DB.runTransaction((transaction) => {
                    // This code may get re-run multiple times if there are conflicts.
                    return transaction.get(userRef)
                    .then((sfDoc) => {
                        if (!sfDoc.exists) {
                            throw "User does not exist!";
                        }
                        
                        var temp = []
                        temp.push(localStorage.playerId)

                        if (sfDoc.data().playerId) {
                            var temp = sfDoc.data().playerId;

                            if (temp.includes(localStorage.playerId)) {
                              console.log("You already subscribed for Notification")
                            } else {
                                if (temp.length < 3) {
                                  temp.push(localStorage.playerId)
                                } else {
                                  temp.shift()
                                  temp.push(localStorage.playerId)
                                }
                            }
                        } else {
                            var temp = []
                            temp.push(localStorage.playerId)
                        }

                        transaction.update(userRef, { playerId: temp })
                    })
                    .catch(err => {
                        console.log("Error: "+err)
                    })
                })
            }
        })
        .catch((error) => {
          this.$store.dispatch('setSnackText', "Error: "+ error)
        });
      } else {
        this.$store.dispatch('setUserState', false)
        this.$store.dispatch('setUserData', null)
        localStorage.removeItem('uid')
      }
    });

    // Sets up offline data presistence 
    DB.enablePersistence()
    .catch(err => {
      if(err.code == 'failed-precondition'){
        // Probably multiple tabs open at once
        console.log('Persistence failed');
      } else if(err.code == 'unimplemented'){
        // Lack browser support
        console.log('persistence is not available');
      }
    });

    // Initializes Onesignal Api For push notification
    var OneSignal = window.OneSignal || [];
    OneSignal.push(function() {
      OneSignal.init({
        appId: process.env.VUE_APP_ONESIGNAL_API_KEY,
        autoRegister: false,
        notifyButton: {
          enable: false,
        },
        welcomeNotification: {
          "title": "Thanks for subscribing!",
          "message": "LOJ - Campus number one accomodation portal",
          // "url": "" /* Leave commented for the notification to not open a window on Chrome and Firefox (on Safari, it opens to your webpage) */
        },
        promptOptions: {
          /* actionMessage limited to 90 characters */
          actionMessage: "We would like to notify you on latest lodges available!",
          /* acceptButtonText limited to 15 characters */
          acceptButtonText: "ALLOW",
          /* cancelButtonText limited to 15 characters */
          //cancelButtonText: "NO THANKS"
        }
      });
      
     OneSignal.registerForPushNotifications();

      if (Notification.permission === "granted") {
        OneSignal.registerForPushNotifications();
      } else {
        OneSignal.showHttpPrompt();
      }

      // Gets user's PlayerId
      OneSignal.on('subscriptionChange', (isSubscribed) => {
        if (isSubscribed) {
          // If the user subscribed
          OneSignal.getUserId((userId) => {
            localStorage.setItem('playerId', userId)

            if (localStorage.uid) {
              var userRef = DB.collection("users").doc(localStorage.uid)

              DB.runTransaction((transaction) => {
                  // This code may get re-run multiple times if there are conflicts.
                  return transaction.get(userRef)
                  .then((sfDoc) => {
                      if (!sfDoc.exists) {
                          throw "User does not exist!";
                      }
                      
                      if (sfDoc.data().playerId) {
                          var temp = sfDoc.data().playerId;

                          if (temp.includes(userId)) {
                            console.log("PlayerId already exists For user")
                          } else {
                              if (temp.length < 3) {
                                temp.push(userId)
                              } else {
                                temp.shift()
                                temp.push(userId)
                              }
                          }
                      } else {
                          var temp = []
                          temp.push(userId)
                      }
                      transaction.update(userRef, { playerId: temp })
                  })
                  .then(() => {
                      console.log("PlayerId has been updated!")
                  })
                  .catch(err => {
                      console.log("Error: "+err)
                  })
              })
            }
          })
        } else {
          location.removeItem("playerId")
          console.log("Subscription cancelled!")
        }
      })
    });

    // Registers a service worker for PWA
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
      .then((reg) => console.log('service worker registered!'))
      .catch((err) => console.log('service worker not registered!', err))
    }
  },
  mounted() {
    let self = this

    let statRef = DB.collection("analysis").doc("stats");
         
    statRef.get().then((doc) => {
        let stats = doc.data()

        // initialize fields
        this.$store.state.totalLodges = stats.lodges
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
    
    // Setup background timer
    setTimeout(() => {
      self.$store.state.howItWorks = true
    }, 7000)
  },
  methods: {}
}
</script>

<style>
  .hero-border {
    border: 1px solid rgba(0,0,0,0.10)!important;
  }
  .pointer {
    cursor: pointer!important;
  }
  .hover:hover {
    background: #f5f5f5!important;
  }
  .hero-text-shadow {
    text-shadow: 1px 0 3px rgba(0,0,0,0.3);
  }
  .badge .v-badge__badge {
    top: 5px!important;
    right: 4px!important;
  }
  .badge2 .v-badge__badge {
    top: 12px!important;
    left: 18px!important;
    z-index: 100;
  }
  .hero-text-f5 {
    color: #f5f5f5!important;
  }
  .hero-bb1 {
    border-bottom: 2px solid #32cd31!important;
  }
  .main {
    background: #fff!important;
  }
  .hero-ba-ads {
    border: 1px solid rgba(0,0,0,0.10)!important;
  }
  .relative {
    position: relative;
  }
  .bb-hero1 {
    border-bottom: 3px solid #32CD32!important;
  }
  .lighter {
    border-color: rgba(0,0,0,0.04)!important;
  }
  .dark-overlay {
    background: rgba(0,0,0,0.3);
  }
  .v-menu__content {
    border-radius: 0px!important;
  }
  .bra-0 {
    border-radius: 0px!important;
  }
  .v-text-field--box > .v-input__control > .v-input__slot{
    border-radius: 0px!important;
  }
  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    border-radius: 0px!important;
  }
  .pointer * {
    cursor: pointer!important;
  }

  /* Login Modal style */
  .text-field-curve .v-input__slot {
      border-radius: 50px!important;
      border: 1px solid #eee;
  }

  .text-field-no-curve .v-input__slot {
      border-radius: 0px!important;
      border: 1px solid #eee;
  }

  .beta {
      background: orange;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      padding: 2px 5px;
      border-radius: 5px;
      position: relative;
      bottom: 5px;
  }

  @media only screen and (min-width: 960px) {
    .badge .v-badge__badge {
      top: 10px!important;
      right: 4px!important;
    }
  }

</style>